import React from 'react';
import { Collection } from '@ai-platform/database';

import { PromptCardData } from '../types';

export enum Entity {
    Prompt = 'prompt',
    Challenge = 'challenge',
    Course = 'course',
    Collection = 'collection',
}

export type FeedProps = {
    containerClassName?: string;
    className?: string;
    isLoading?: boolean;
    needInfinity?: boolean;
    columns?: number;
    collections?: Collection[];
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    prompts?: any[];
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    challenges?: any[];
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    courses?: any[];
    onPromptClick?: (prompt: PromptCardData) => void;
    withHover?: boolean;
    /** Есть ли еще данные для загрузки */
    hasMore?: boolean;
    /** Функция для загрузки следующей порции данных */
    onLoadMore?: () => void;
    /** Ref для контейнера скролла */
    containerRef?: React.RefObject<HTMLDivElement | null>;
    showStatuses?: boolean;
    /** Показывать ли карточку создания нового промпта */
    showNewPromptCard?: boolean;
    /** Нужно ли помечать просмотренность промптов */
    needMarkPromptsAsViewed?: boolean;
    /** Место, где используется фид */
    place: FeedPlace;
};

export enum FeedPlace {
    HomePage = 'HomePage',
    Popular = 'Popular',
    PromoResearch = 'PromoResearch',
    PromoMuseumNight = 'PromoMuseumNight',
    Search = 'Search',
    Profile = 'Profile',
    PromptPage = 'PromptPage',
}

export type FeedData = {
    collections: Collection[];
    prompts: PromptCardData[];
    challenges: PromptCardData[];
    courses: PromptCardData[];
};

export type Matrix = {
    [key: number]: {
        prompts?: number;
        challenge?: number;
        courses?: number;
        collections?: number;
        default?: string;
        priority?: string;
        weight: number;
    };
};
